// row 102 TimeZone (`tz`, DS call 4: "every time on the page shows the event time zone first"): the *Time zone* select,
// small (34 px), pinned at the free/busy grid's foot, and the dual-time line under it — the time in the event zone
// first, then an attendee's local time in --text-3. The select is F4b's native Select inside a Field, so it keeps the
// browser's list and keyboard, the blocked values-only view and mode="view".

import type { ReactNode } from "react";
import { Field, Select, type Blocked, type SelectOption } from "../core";
import { cx } from "../lib/cx";
import { SCHEDULING_LABELS } from "./labels";
import type { Hs } from "../lib/hs";

export interface TimeZoneProps {
  /** The zones offered (the event's zone preserved from the meeting first). */
  options: readonly SelectOption[];
  value?: string | undefined;
  defaultValue?: string | undefined;
  onChange?: ((value: string) => void) | undefined;
  /** The time in the event zone. */
  event?: ReactNode | undefined;
  /** An attendee's local time, shown after it in --text-3. */
  local?: ReactNode | undefined;
  blocked?: Blocked | undefined;
  mode?: "edit" | "view" | undefined;
  can?: boolean | undefined;
  hs?: Hs | undefined;
  id?: string | undefined;
  className?: string | undefined;
}

export function TimeZone({ options, value, defaultValue, onChange, event, local, blocked, mode, can, hs, id, className }: TimeZoneProps) {
  if (can === false) return null;
  return (
    <div className={cx("mc-tz", className)}>
      <Field label={SCHEDULING_LABELS.timeZoneField} blocked={blocked} mode={mode} id={id}>
        <Select sm options={options} value={value} defaultValue={defaultValue} onChange={onChange ? (next) => onChange(next) : undefined} hs={hs} />
      </Field>
      {event !== undefined || local !== undefined ? (
        <p className="mc-tz-dual">
          {event !== undefined ? <time>{event}</time> : null}
          {event !== undefined && local !== undefined ? " · " : null}
          {local !== undefined ? <span className="mc-t3">{local}</span> : null}
        </p>
      ) : null}
    </div>
  );
}
